const imageModules = import.meta.glob('./*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const allImages = Object.entries(imageModules)
  .map(([path, src]) => ({ path, src: src as string }))
  .sort((a, b) => a.path.localeCompare(b.path));

const floorPlanFiles = allImages.filter(i => i.path.includes('3D-layout'));
const photoFiles = allImages.filter(i => !i.path.includes('3D-layout'));

export const ukubinuImages: string[] = photoFiles.map(i => i.src);
export const ukubinuFloorPlans = [
  { image: floorPlanFiles.find(f => f.path.includes('1NP'))!.src, label: '1. NP' },
  { image: floorPlanFiles.find(f => f.path.includes('2.NP'))!.src, label: '2. NP' },
  { image: floorPlanFiles.find(f => f.path.includes('3.NP'))!.src, label: '3. NP' },
];
